namespace TabAurous.Retail {
    export interface POSSalesTaxRow {
        TransTaxId?: number;
        TransId?: number;
        HSN?: string;
        ProductTypeId?: number;
        NetAmount?: number;
        TaxId?: number;
        TaxRate?: number;
        TaxAmount?: number;
        CessId?: number;
        CessRate?: number;
        CessAmount?: number;
        TaxType?: string;
        TaxName?: string;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        TaxLedgerId?: number;
        CessLedgerId?: number;
        State?: string;
        B2CSType?: string;
        ECommGST?: string;
    }

    export namespace POSSalesTaxRow {
        export const idProperty = 'TransTaxId';
        export const nameProperty = 'HSN';
        export const localTextPrefix = 'Retail.POSSalesTax';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            TransTaxId = "TransTaxId",
            TransId = "TransId",
            HSN = "HSN",
            ProductTypeId = "ProductTypeId",
            NetAmount = "NetAmount",
            TaxId = "TaxId",
            TaxRate = "TaxRate",
            TaxAmount = "TaxAmount",
            CessId = "CessId",
            CessRate = "CessRate",
            CessAmount = "CessAmount",
            TaxType = "TaxType",
            TaxName = "TaxName",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            TaxLedgerId = "TaxLedgerId",
            CessLedgerId = "CessLedgerId",
            State = "State",
            B2CSType = "B2CSType",
            ECommGST = "ECommGST"
        }
    }
}
